import React, { useContext } from 'react'
import { SectionColumn } from '../layout'
import { SelectInput } from '../layout/form/input'
import { StateStore } from '../../containers/StoreProvider'
import { getAlArcOptions } from '../ALSubForm/options'
import { INVALID_ARC_DESCRIPTION_CODE } from '../ALSubForm/types'

interface AlArcCodesFormInterface {
  getValue: (value: string) => string
  setValue: (field: string, value: string) => void
  componentRequired?: boolean
  descriptionRequired?: boolean
  disableArcComponent?: boolean
  disableArcDescription?: boolean
}
export const AlArcCodesForm = ({
  getValue,
  setValue,
  componentRequired = false,
  descriptionRequired = false,
  disableArcComponent,
  disableArcDescription,
}: AlArcCodesFormInterface) => {
  const {
    state: { AlArcCodes },
  } = useContext(StateStore)

  const arcComponentCode = getValue('automobileAndTouringClubFinland.arcCodes.component.code')
  const arcDescriptionCode = getValue('automobileAndTouringClubFinland.arcCodes.description.code')

  const { arcComponentOptions, arcDescriptionOptions } = getAlArcOptions(
    arcComponentCode,
    arcDescriptionCode,
    AlArcCodes
  )

  const handleOnComponentChange = () => {
    if (Number(arcDescriptionCode) === INVALID_ARC_DESCRIPTION_CODE) {
      return
    }

    setValue('automobileAndTouringClubFinland.arcCodes.description.code', '')
  }

  return (
    <>
      <SectionColumn>
        <SelectInput
          label="Komponentti (ARC-vikakoodi)"
          required={componentRequired}
          disabled={disableArcComponent}
          name="automobileAndTouringClubFinland.arcCodes.component.code"
          onChange={handleOnComponentChange}
          options={arcComponentOptions}
        />
      </SectionColumn>
      <SectionColumn>
        <SelectInput
          label="Vian kuvaus (ARC-vikakoodi)"
          disabled={disableArcDescription}
          required={descriptionRequired}
          name="automobileAndTouringClubFinland.arcCodes.description.code"
          options={arcDescriptionOptions}
        />
      </SectionColumn>
    </>
  )
}
